
import { useStore } from 'vuex'
import { computed, defineComponent, onMounted, reactive } from 'vue'
import dayjs, { Dayjs } from 'dayjs'
import {appURL} from "@/axios";

export default defineComponent({
  components: {},
  setup () {
    const store = useStore()
    const filter = reactive({
      site_id: '',
      from: '',
      to: '',
      site_product_id: '',
    })

    const getAllSites = () => {
      store.dispatch('Option/getAllSites')
    }

    const getAllSiteProduct = (payload: any) => {
      store.dispatch('Option/getAllSiteProduct', payload)
    }

    const handleChange = (payload: any) => {
      getAllSiteProduct({
        ...payload,
        selected_site_id: payload
      })
    }

    const handleExportToExcel = (e: any) => {
      let api_url = process.env.VUE_APP_URL
      window.location.href = appURL + `backend/exports/variance?type=xlsx&site_id=${filter.site_id}&
      site_product_id=${filter.site_product_id}&from=${dayjs(filter.from, 'YYYY-MM-DD')}
      &to=${dayjs(filter.to, 'YYYY-MM-DD')}`
    }

    const handleExportToPDF = (e: any) => {
      let api_url = process.env.VUE_APP_URL
      window.location.href = appURL + `backend/exports/variance?type=pdf&site_id=${filter.site_id}
      &site_product_id=${filter.site_product_id}&from=${dayjs(filter.from, 'YYYY-MM-DD')}
      &to=${dayjs(filter.to, 'YYYY-MM-DD')}`
    }

    const disabledDate = (current: Dayjs) => {
      return current > dayjs().endOf('day')
    }

    const filterOption = (input, option) => {
      return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }

    const setDisableExcel = () => {
      return filter.site_id === '' || filter.from === '' || filter.to === '' || filter.site_product_id === ''
    }

    const setDisablePdf = () => {
      return filter.site_product_id === "all" || filter.site_id === '' || filter.from === '' || filter.to === '' || filter.site_product_id === ''
    }

    const all_sites = computed(() => store.getters['Option/all_sites'])
    const all_site_products = computed(() => store.getters['Option/all_site_products'])
    const isDisabledExcel = computed(() => setDisableExcel())
    const isDisabledPdf = computed(() => setDisablePdf())

    onMounted(() => {
      getAllSites()
    })

    return {
      filter,
      all_sites,
      all_site_products,
      handleChange,
      handleExportToExcel,
      handleExportToPDF,
      isDisabledExcel,
      isDisabledPdf,
      disabledDate,
      filterOption
    }
  }
})
